<div class="tw-w-full tw-p-5 tw-pt-10 tw-relative tw-bg-gray-75 tw-rounded-t-6 tw-font-body">
  <div class="tw-mb-6"
       [class]="{'tw-font-lexend': data?.acqRebranding2025, 'tw-font-body': data?.acqRebranding2025}">
    <h1 i18n="@@shareBothSidesForCompleteAnalysis"
        class="tw-text-600"><span class="tw-font-bold">Share both sides</span><br /> for complete analysis</h1>
  </div>
  <div class="tw-w-full tw-flex tw-gap-4 tw-mb-6">
    <ng-container>
      <!-- Left side image -->
      <div class="tw-w-1/2 tw-flex tw-flex-col tw-items-center">
        <div class="tw-w-full tw-border-2 tw-border-white tw-mb-2 tw-rounded-2 tw-shadow-z1">
          <img *ngIf="leftSideImage?.image"
               class="tw-w-full tw-aspect-[9/11] tw-object-cover tw-rounded-[7px]"
               [src]="leftSideImage?.image"
               alt="" />
          <div *ngIf="!leftSideImage?.image"
               (click)="uploadImage()"
               class="tw-w-full tw-aspect-[9/11] tw-bg-gray-200 tw-flex tw-justify-center tw-items-center tw-rounded-[7px]"
               [class]="{'tw-bg-[#EAEAEA]': data?.acqRebranding2025, 'tw-bg-gray-200': !data?.acqRebranding2025}">
            @if (data?.acqRebranding2025) {
            <img src="/assets/images/left-face.png"
                 class="tw-h-24 tw-w-auto"
                 alt="left face">
            } @else {
            <img src="https://cdn.cureskin.com/app/img/add_photo.svg"
                 class="tw-w-7"
                 alt="camera icon">
            }
          </div>
        </div>
        <h1 i18n="@@leftSide"
            class="tw-uppercase tw-text-200 tw-text-gray-500">Left Side</h1>
      </div>

      <!-- Right side image -->
      <div class="tw-w-1/2 tw-flex tw-flex-col tw-items-center">
        <div class="tw-w-full tw-border-2 tw-border-white tw-mb-2 tw-rounded-2 tw-shadow-z1">
          <img *ngIf="rightSideImage?.image"
               class="tw-w-full tw-aspect-[9/11] tw-object-cover tw-rounded-[7px]"
               [src]="rightSideImage?.image"
               alt="" />
          <div *ngIf="!rightSideImage?.image"
               (click)="uploadImage()"
               class="tw-w-full tw-aspect-[9/11] tw-bg-gray-200 tw-flex tw-justify-center tw-items-center tw-rounded-[7px]"
               [class]="{'tw-bg-[#EAEAEA]': data?.acqRebranding2025, 'tw-bg-gray-200': !data?.acqRebranding2025}">
            @if (data?.acqRebranding2025) {
            <img src="/assets/images/left-face.png"
                 class="tw-h-24 tw-w-auto tw-scale-x-[-1]"
                 alt="left face">
            } @else {
            <img src="https://cdn.cureskin.com/app/img/add_photo.svg"
                 class="tw-w-7"
                 alt="camera icon">
            }
          </div>
        </div>
        <h1 i18n="@@rightSide"
            class="tw-uppercase tw-text-200 tw-text-gray-500">Right Side</h1>
      </div>
    </ng-container>
  </div>

  <div class="tw-mb-3 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3">
    <span *ngIf="rightSideImage?.image"
          class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300
      tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden"
          (click)="uploadImage()"
          i18n="@@takeLeftSidePhoto">
      Take Left side photo
    </span>
    <span *ngIf="leftSideImage?.image"
          class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300
      tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden"
          (click)="uploadImage()"
          i18n="@@takeRightSidePhoto">
      Take Right side photo
    </span>
    <span class="tw-text-300 tw-text-teal-600 tw-p-2 tw-font-bold"
          i18n="@@skip"
          (click)="closedPopup(true)">Skip</span>
  </div>

  <div class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-3 tw-right-3 close-sheet"
       style="width: 35px; height: 35px"
       (click)="closedPopup()">
    <div class="tw-text-gray-500 tw-text-500 tw-font-bold">&#10005;</div>
  </div>
</div>
